import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { ReactElement, useCallback } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import * as yup from 'yup';
import PmiTextField from 'shell/components/shared/text-field';

export interface DocumentSerieForm {
  number?: string;
  description?: string;
}

const validationSchema = yup.object({
  number: yup.string().required('Il campo è obbligatorio'),
  description: yup.string().required('Il campo è obbligatorio'),
});

interface FormDocumentSerieProps {
  onOk: (form: DocumentSerieForm) => void;
  onCancel: (form?: DocumentSerieForm) => void;
  title: string;
  children?: ReactElement;
  disabled?: boolean;
  isEdit?: boolean;
  initialValues?: DocumentSerieForm;
}

const FormDocumentSerie = ({
  onOk,
  onCancel,
  title,
  disabled = false,
  isEdit,
  initialValues,
}: FormDocumentSerieProps): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const formDocumentSerie = useFormik<DocumentSerieForm>({
    initialValues: initialValues || {
      number: '',
      description: '',
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
    validateOnMount: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={formDocumentSerie.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Codice"
                  label="Codice *"
                  id="number"
                  name="number"
                  type="text"
                  variant="outlined"
                  value={formDocumentSerie.values.number || ''}
                  disabled={disabled || isEdit}
                  fullWidth
                  inputProps={{
                    maxLength: '2',
                  }}
                  onChange={formDocumentSerie.handleChange}
                  error={
                    formDocumentSerie.touched.number && Boolean(formDocumentSerie.errors.number)
                  }
                  helperText={formDocumentSerie.errors.number}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <PmiTextField
                  aria-label="Descrizione"
                  label="Descrizione *"
                  id="description"
                  name="description"
                  type="text"
                  inputProps={{
                    maxLength: '30',
                  }}
                  variant="outlined"
                  value={formDocumentSerie.values.description || ''}
                  disabled={disabled}
                  fullWidth
                  onChange={formDocumentSerie.handleChange}
                  error={
                    formDocumentSerie.touched.description &&
                    Boolean(formDocumentSerie.errors.description)
                  }
                  helperText={formDocumentSerie.errors.description}
                />
              </Grid>
            </Grid>
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel(formDocumentSerie.values);
            }}
          >
            Annulla
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormDocumentSerie.displayName = 'Form Document Serie component';

export default FormDocumentSerie;
